import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/views/Layout";
import Cookies from "js-cookie";

Vue.use(VueRouter)
const routes = [
    // 登录
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login')
  },
    // 主页
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: '/home',  //重定向
    children:[   //子路由
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/HomeView')
      },
      {
        path: 'userList',
        name:'UserList',
        meta:{name:'用户列表'},
        component: ()=> import('@/views/user/User')
      },
      {
        path: 'addUser',
        name:'AddUser',
        component: ()=> import('@/views/user/AddUser')
      },
      {
        path: 'editUser',
        name:'EditUser',
        component: ()=> import('@/views/user/EditUser')
      },
      //管理员列表
      {
        path: 'adminList',
        name:'AdminList',
        component: ()=> import('@/views/admin/Admin')
      },
      {
        path: 'addAdmin',
        name:'AddAdmin',
        component: ()=> import('@/views/admin/AddAdmin')
      },
      {
        path: 'editAdmin',
        name:'EditAdmin',
        component: ()=> import('@/views/admin/EditAdmin')
      },
      {
        path: 'carousel',
        name:'Carousel',
        component: ()=> import('@/views/carousel/Carousel')
      },
      {
        path: 'editCarousel',
        name:'EditCarousel',
        component: ()=> import('@/views/carousel/EditCarousel')
      },
      {
        path: 'proverb',
        name:'Proverb',
        component: ()=> import('@/views/proverb/Proverb')
      },
      {
        path: 'poem',
        name:'Poem',
        component: ()=> import('@/views/poetry/Poem')
      },
      {
        path: 'poet',
        name:'Poet',
        component: ()=> import('@/views/poetry/Poet')
      },
      {
        path: 'guess',
        name:'Guess',
        component: ()=> import('@/views/guess/Guess')
      },
      {
        path: 'festival',
        name:'Festival',
        component: ()=> import('@/views/culture/Festival')
      },
      {
        path: 'classical',
        name:'Classical',
        component: ()=> import('@/views/culture/Classical')
      },
      {
        path: 'knowledge',
        name:'Knowledge',
        component: ()=> import('@/views/culture/Knowledge')
      },
    ]

  },
  {
    path: "*",
    component: () => import('@/views/404')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//路由守卫，判断是否成功登录
router.beforeEach((to,from,next)=>{
  if (to.path === '/login') next()
  const admin = Cookies.get('admin')   //判断缓存数据是否存在，先存数据才能跳转
  if (!admin && to.path != '/login') return next('/login')
  next()
})

export default router
